export default __webpack_public_path__ + "static/media/NLR-9.5f9c8449.webp";